export default () => ({
  root: {
    display: "flex",
    flex: 1,
    overflow: "hidden",
    position: "absolute",
    background: "#272838",
  },
});
